import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { Trainingreq } from './training-req.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TrainingReqService {
  private apiUrl = `${environment.apiConfig.uri}/training-request`;
  private apiUrlExport = `${environment.apiConfig.uri}/training-request/export`;

  constructor(private http: HttpClient) {
  }

      createTrainingReq(newTrainingReq: Trainingreq): Observable<any> {
          return this.http.post(this.apiUrl, {
            email: newTrainingReq.email,
            type: newTrainingReq.type,
            reason: newTrainingReq.reason,
            date: newTrainingReq.date,
            cost: newTrainingReq.cost,
            online: newTrainingReq.online,
            desc: newTrainingReq.desc,
          })
      }
  
      exportTrainingReqExcel(): Observable<Blob> {
          return this.http.get(this.apiUrlExport, {
              responseType: 'blob'
          })
      }

}


